import { state, actions as base_actions } from "./tenants.module"
import * as additional_actions from "./actions"

const actions = { ...base_actions, ...additional_actions  }

export {
    state,
    actions
} 